import React from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/index';
import { useTranslation } from 'react-i18next';

const ReadSingleDownloadButton = (props) => {

  const documentationFileUserInfoId = props.documentationFileUserInfoId;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const deleteSingleUnreadInfo = (id) => dispatch( actions.deleteSingleDocumentationFileUserInfo(id) );

    return (
       <a onClick={ () => { deleteSingleUnreadInfo(documentationFileUserInfoId) } } style={{marginRight: "0px", color: "white"}} className="btn btn-primary btn-project">{ t('button.downloads.read') }</a>
    )
}


export default ReadSingleDownloadButton;



// WEBPACK FOOTER //
// ./src/components/Documentations/ReadSingleDownloadButton.js